import type { PreloadedQuery } from 'react-relay';
import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import DEPLOYMENTS_PRECONDITION_QUERY, {
	type uiDeploymentsFeaturePreconditionQuery,
} from '@atlassian/jira-software-deployments-precondition/src/ui/__generated__/uiDeploymentsFeaturePreconditionQuery.graphql';
import {
	RESOURCE_TYPE_DEPLOYMENTS_PRECONDITION,
	RESOURCE_TYPE_DEPLOYMENTS_PRECONDITION_RELAY,
} from '../constants.tsx';
import type { PreconditionResult } from '../types.tsx';

export const deploymentPreconditionResource: RouteResource<PreconditionResult> =
	createResource<PreconditionResult>({
		type: RESOURCE_TYPE_DEPLOYMENTS_PRECONDITION,
		getKey: ({ query }) => query.projectKey,
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-deployments-precondition", jiraSpaEntry: "async-resource-deployments-precondition" */ './get-data'
			),
		maxAge: 60 * 1000,
	});

export const deploymentPreconditionRelayResource: RouteResource<
	PreloadedQuery<uiDeploymentsFeaturePreconditionQuery, Record<string, unknown>>
> = createRelayResource<uiDeploymentsFeaturePreconditionQuery>({
	type: RESOURCE_TYPE_DEPLOYMENTS_PRECONDITION_RELAY,
	getQuery: ({ match }, { tenantContext }) => ({
		parameters: DEPLOYMENTS_PRECONDITION_QUERY,
		variables: {
			cloudId: tenantContext.cloudId,
			projectKey: String(match.params.projectKey),
		},
		options: { fetchPolicy: 'store-and-network' },
	}),
});
